var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.005 21.0088V21.0088C11.3915 19.781 10.1361 19.0062 8.76362 19.0081H4.50125C4.10341 19.0081 3.72187 18.8501 3.44056 18.5688C3.15926 18.2875 3.00122 17.9059 3.00122 17.5081V17.5081V5.5021C3.00122 5.10427 3.15926 4.72273 3.44056 4.44142C3.72187 4.16011 4.10341 4.00208 4.50125 4.00208H8.0037C9.06491 4.00208 10.0826 4.42364 10.833 5.17402C11.5834 5.9244 12.005 6.94214 12.005 8.00334V8.00334V21.0088Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0049 21.0086C12.6184 19.7809 13.8738 19.006 15.2462 19.008H19.5122C20.3392 19.006 21.0086 18.335 21.0086 17.508V5.50198C21.0086 5.10415 20.8506 4.72261 20.5693 4.4413C20.288 4.15999 19.9064 4.00195 19.5086 4.00195H16.0061C13.7963 4.00195 12.0049 5.79338 12.0049 8.00322V21.0086Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documentsIcon.2a7b40b83557a5750c9041efcc9a3fe2.svg";
export { ForwardRef as ReactComponent };